import React, { memo } from 'react'
import { Text } from 'common-components'

interface IProps {
  children: React.ReactNode
}

const AiImageGenerationTabTitle: React.FC<IProps> = ({ children }) => {
  return (
    <Text type="subtitle" color="secondaryDark">
      {children}
    </Text>
  )
}

export default memo(AiImageGenerationTabTitle)
